import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FormInstance } from 'antd'
import { GET_API_TOKEN, SET_API_TOKEN } from '../../constants/apiConstants'
import { decrypt, encrypt } from '../../helpers/Crypt'
import { State } from '../../types/StateType'
import {
  authReducerType,
  changePasswordType,
  forgotPasswordDataType,
  loginDataType,
  UserDataType,
} from './types'

let initialState: authReducerType = {
  error: null,
  loading: false,
  success: null,
  token: GET_API_TOKEN(),
  userData: null,
  imageUrl: '',
}

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    login: (state, action: PayloadAction<loginDataType>) => {},
    forgotPassword: (
      state,
      action: PayloadAction<forgotPasswordDataType>
    ) => {},
    changePassword: (state, action: PayloadAction<changePasswordType>) => {},
    updateUser: (state, action: PayloadAction<UserDataType>) => {},
    setUserData: (state, action: PayloadAction<UserDataType>) => {
      let imageFromState = state.userData?.image
      state.userData = {
        ...action.payload,
        image: imageFromState ? imageFromState : action.payload.image,
      }
      let dataString = encrypt(JSON.stringify(state.userData))
      sessionStorage.setItem('data', dataString)
    },
    getImageUrl: (state, action: PayloadAction<string>) => {},
    setImageUrl: (state, action: PayloadAction<string>) => {
      state.imageUrl = action.payload
    },
    setImageFileNameToData: (state, action: PayloadAction<string>) => {
      if (state.userData) {
        let newUserData = {
          ...state.userData,
          image: action.payload,
        }
        state.userData = newUserData
      }
      let dataString = encrypt(JSON.stringify(state.userData))
      sessionStorage.setItem('data', dataString)
    },
    setUserDataForForm: (
      state: authReducerType,
      action: PayloadAction<FormInstance>
    ) => {
      let dataString = sessionStorage.getItem('data')
      if (state.userData) {
        action.payload.setFieldsValue({
          ...state.userData,
        })
      } else if (dataString) {
        let dataDecoded = decrypt(dataString)
        let data = JSON.parse(dataDecoded)
        action.payload.setFieldsValue({
          ...data,
        })
        state.userData = data
      }
    },
    getHospitalName: (state: authReducerType) => {
      let dataString = sessionStorage.getItem('data')
      if (dataString) {
        let dataDecoded = decrypt(dataString)
        let data = JSON.parse(dataDecoded)
        state.userData = data
      }
    },
    removeToken: (state) => {
      SET_API_TOKEN('')
    },
    errorAuth: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    successAuth: (state, action: PayloadAction<string | null>) => {
      state.success = action.payload
    },
  },
})

export const {
  errorAuth,
  successAuth,
  removeToken,
  login,
  forgotPassword,
  updateUser,
  setImageFileNameToData,
  setUserData,
  setUserDataForForm,
  changePassword,
  getHospitalName,
  getImageUrl,
  setImageUrl,
} = authSlice.actions

export default authSlice.reducer

export const selectErrorInAuth = createSelector(
  (state: State) => state.authState.error,
  (error) => error
)
export const selectSuccessInAuth = createSelector(
  (state: State) => state.authState.success,
  (success) => success
)
export const selectHospitalName = createSelector(
  (state: State) => state.authState.userData?.hospitalName,
  (hospitalName) => {
    return hospitalName
  }
)
export const selectHospitalId = createSelector(
  (state: State) => state.authState.userData?.hk,
  (hk) => {
    return hk
  }
)
export const selectImageUrl = createSelector(
  (state: State) => state.authState.imageUrl,
  (imageUrl) => {
    return imageUrl
  }
)
export const selectProfileName = createSelector(
  (state: State) => state.authState.userData,
  (userData) => {
    if (userData?.firstName)
      return `${userData.title} ${userData.firstName} ${userData.lastName}`
    else return ''
  }
)
export const selectAccountUk = createSelector(
  (state: State) => state.authState.userData?.uk,
  (uk) => ({ uk })
)
export const selectProfilePictureImage = createSelector(
  (state: State) => state.authState.userData,
  (userDate) => {
    if (userDate) return userDate.image
    else {
      let dataString = sessionStorage.getItem('data')
      if (dataString) {
        let dataDecoded = decrypt(dataString)
        let data = JSON.parse(dataDecoded)
        return data.image
      } else {
        return undefined
      }
    }
  }
)
